import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52b6c4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 返回 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 下载 ")
const _hoisted_4 = { class: "order-info" }

import {
  ref,
  onMounted,
  nextTick
} from 'vue'
import { $post, $exportExcel } from '@/utils/https'
import { ElMessageBox, ElMessage } from 'element-plus'
import type { ElTable } from 'element-plus'
import storage, { StorageType } from '@/utils/storage'
import Keys from '@/constant/key'
import { PreOrderProduct, PreOrderProducts } from '@/model/product'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: null
  },
  emits: ["back"],
  setup(__props: any, { expose, emit }: { emit: ({(e: 'back', val: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id: number
}

const loading = ref(false)
const allQty = ref(0)
const totaMoney = ref(0)
const multipleTableRef = ref<InstanceType<typeof ElTable>>()
const multipleSelection = ref<PreOrderProduct[]>([])
const tableData = ref<PreOrderProduct[]>([])


const back = () => {
  emit('back', true)
}
onMounted(() => {
  loadDate()
})
const loadDate = () => {
  if (!props.id) {
    ElMessage.error('缺少参数!')
    return
  }
  $post<PreOrderProducts>({
    url: '/order/selection/detail',
    loading: true,
    data: {
      id: props.id
    }
  }).then((res) => {
    if (res.data && res.data.product.length > 0) {
      tableData.value = calculateListMoney(res.data.product)
      nextTick(() => {
        tableData.value.forEach((row) => {
          multipleSelection.value.push(row)
          if (multipleTableRef.value) {
            multipleTableRef.value.toggleRowSelection(row, true)
          }
        })
      })
    }
  }).catch((err) => {
    if (err.message) {
      ElMessage.error(err.message)
    }
  })
}
const clearData = () => {
  // multipleSelection.value = []
  // tableData.value = []
}
expose({ clearData })

const calculateListMoney = (list: PreOrderProduct[]) => {
  allQty.value = 0
  totaMoney.value = 0
  return list.map((item) => {
    item.qty = item.qty || 1
    const money = parseFloat(item.type === 2 ? item.carton.price : item.price) * item.qty
    item.totalMoney = money.toFixed(2)
    totaMoney.value += money || 0
    allQty.value += item.qty
    return item
  })
}
const qtyInputChange = () => {
  calculateListMoney(multipleSelection.value)
}

const handleSelectionChange = (val) => {
  multipleSelection.value = val
  calculateListMoney(val)
}

const cellClass = (val) => {
  if (val.column.label === '产品图') {
    return 'i-cell-img-clas'
  }
}
const headerCellClass = () => {
  return 'i-header-cell-class'
}
const submit = () => {
  if (multipleSelection.value.length <= 0) {
    ElMessage.error('请选择商品')
    return
  }
  loading.value = true
  $post<number>({
    url: '/order/quote/create',
    data: {
      selection_id: props.id,
      product: JSON.stringify(
        multipleSelection.value.map((item) => {
          return {
            product_id: item.id,
            qty: item.qty || 1
          }
        })
      )
    }
  }).then((res) => {
    exportExcel(res.data.id)
  }).catch((err) => {
    loading.value = false
    if (err.message) {
      ElMessage.error(err.message)
    }
  })
}
const exportExcel = (id: number) => {
  $exportExcel({
    url: '/order/quote/export',
    data: {
      id: id
    }
  }).then((res) => {
    loading.value = false
    if (!res.data) return
    const blob = new Blob([res.data], {
      type: 'application/vnd.ms-excel;charset=utf8'
    })
    const url = window.URL.createObjectURL(blob)
    const aLink = document.createElement('a')
    aLink.style.display = 'none'
    aLink.href = url
    aLink.setAttribute('download', `报价单${new Date().getTime()}.xlsx`)
    document.body.appendChild(aLink)
    aLink.click()
    setTimeout(() => {
      window.URL.revokeObjectURL(url) // 释放URL 对象
      document.body.removeChild(aLink)
    }, 500)
    storage.rcRemoveItem(StorageType.local, Keys.cartsKey)
    ElMessageBox.alert('您已成功生成报价单,可在下载中心查看！', '', {
      confirmButtonText: '确定',
      showClose: false,
      center: true,
      callback: () => {
        back()
      }
    })
  }).catch((err) => {
    loading.value = false
    if (err.message) {
      ElMessage.error(err.message)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "pre-order-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_table, {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          class: "i-table",
          height: "100%",
          "empty-text": "暂无数据",
          data: tableData.value,
          "cell-class-name": cellClass,
          "header-cell-class-name": headerCellClass,
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "selection" }),
            _createVNode(_component_el_table_column, {
              prop: "product_name",
              label: "产品名称",
              "min-width": "200px"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "main_img",
              label: "产品图",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_image, {
                  class: "img-url",
                  src: scope.row.main_img,
                  "preview-src-list": [scope.row.main_img],
                  fit: "contain",
                  loading: "lazy"
                }, {
                  error: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      src: require('Assets/images/img_product_err_img.png'),
                      fit: "contain"
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["src", "preview-src-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "净含量*箱规数" }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString((scope.row.volumn +'*'+ scope.row.carton.spec + scope.row.unit) || "无"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "unit",
              label: "单位",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.unit || "无"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "单价",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.type === 2 ? scope.row.carton.price : scope.row.price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "购买数量",
              prop: "qty",
              width: "200",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input_number, {
                  step: 1,
                  min: 1,
                  max: 9999,
                  onChange: ($event: any) => (qtyInputChange(scope.$index)),
                  style: {"width":"70%"},
                  "step-strictly": "",
                  modelValue: scope.row.qty,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.qty) = $event),
                  modelModifiers: { number: true }
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "预估价",
              prop: "totalMoney",
              width: "160"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createVNode(_component_el_footer, { class: "foot" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "back",
            type: "info",
            onClick: back
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            class: "create-order",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 总商品" + _toDisplayString(multipleSelection.value.length) + "件，共计" + _toDisplayString(allQty.value) + "份，预估总价:", 1),
            _createElementVNode("span", null, _toDisplayString(totaMoney.value.toFixed(2)) + "元", 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})